import GTMScript from "@/component/Ads/GTMScript";
import BreadcrumbSchema from "@/component/SeoTags/BreadcrumbSchema";
import HeadTag from "@/component/SeoTags/HeadTag";

const index = () => {
  return (
    <article className="mx-4">
      <HeadTag
        title="Terms and Conditions - NewsTak"
        description="Get all details about terms & Condition of NewsTak. "
        keywords="terms and condition NewsTak"
        canonicalUrl={
          process.env.NEXT_PUBLIC_WEBSITE_URL + "/terms-and-conditions"
        }
      />
      <GTMScript />
      <BreadcrumbSchema
        breadcrumbList={[
          {
            title: "Terms and Conditions",
            canonical_url:
              'process.env.NEXT_PUBLIC_WEBSITE_URL + "/terms-and-conditions"',
          },
        ]}
      />
      <h1 className="text-2xl font-bold">Terms and Conditions</h1>
      <div className="mt-4 flex flex-col gap-4">
        <h2 className="text-lg font-bold">INDIA TODAY GROUP SERVICE TERMS</h2>
        <p className="text-slate-600 text-md">
          Effective date 10-01-2007 Please read these Terms and Conditions
          carefully before using this Web Site. If you do not agree to these
          Terms and Conditions exit now and do not use this Web Site.
        </p>
        <p className="text-slate-600 text-md">
          <strong className="text-lg text-slate-950 py-2">1. Acceptance</strong>
        </p>
        <p className="text-slate-600 text-md">
          Effective date 10-01-2007 Please read these Terms and Conditions
          carefully before using this Web Site. If you do not agree to these
          Terms and Conditions exit now and do not use this Web Site.
        </p>
        <p className="text-slate-600 text-md">
          <strong className="text-lg text-slate-950 py-2">
            2. Registration and Termination
          </strong>
        </p>
        <p className="text-slate-600 text-md">
          To use a Service you may need to register and create an account with a
          username and a password. You may need to provide us with certain
          personal and other information. INDIA TODAY GROUP may verify your
          email address before your account can be used.
          <br />
          You agree to provide truthful and complete information when you
          register for the Service and to keep that information updated. You
          must take due care to protect your username and password against
          misuse by others and promptly notify INDIA TODAY GROUP about any
          misuse. You are personally responsible for any use of the Service.
          <br />
          You may terminate your registration if you no longer wish to use the
          Service. After termination, you will no longer have access to the
          Service. INDIA TODAY GROUP may terminate your registration or restrict
          your access to certain parts of the Service if INDIA TODAY GROUP
          reasonably believes that you have breached the Terms.
        </p>
        <p className="text-slate-600 text-md">
          <strong className="text-lg text-slate-950 py-2">3. Licenses</strong>
        </p>
        <p className="text-slate-600 text-md">
          INDIA TODAY GROUP grants you a non-exclusive, non-transferable
          license, revocable at any time at INDIA TODAY GROUP’s sole discretion,
          to access and use the Service strictly in accordance with the Terms.
          Use of the Service does not grant you any intellectual property rights
          in or to any information or content in the Service.
          <br />
          As part of the Service, INDIA TODAY GROUP may provide you with content
          developed by INDIA TODAY GROUP or its licensors (“Content”). INDIA
          TODAY GROUP grants you a non-exclusive license to use the Content for
          the purpose it is intended, unless otherwise defined in the applicable
          Terms or the purchase order. The INDIA TODAY GROUP, however, retains
          the right to withdraw the aforementioned license at its sole
          discretion.
          <br />
          You are bound by any restrictions applicable to specific Content you
          obtain through the Service. Any license acquired to third-party
          Content is a binding agreement between you and the third-party Content
          provider. You have only the rights to the Content which are expressly
          granted herein. Any liability arising out of your use of the Content
          shall be solely to your account and the INDIA TODAY GROUP shall not
          take any responsibility for the same.
          <br />
          As part of the Service, INDIA TODAY GROUP may provide you with certain
          software developed by INDIA TODAY GROUP or, its licensors
          (“Software”). Your use of Software may be subject to separate terms
          and conditions that you must accept before using the Software.
          <br />
          If there are no separate terms and conditions applicable to such
          Software, the following terms apply: INDIA TODAY GROUP grants to you a
          limited, non-exclusive, non-transferable right to install and use the
          Software on your computer and/or mobile device in order to use the
          Service.
          <br />
          You may not distribute, transfer the right to use, modify, translate,
          reproduce, resell, sublicense, rent, lease, reverse engineer, or
          otherwise attempt to discover the source code of or make derivative
          works of the Software. For open source licensed software, applicable
          open source license terms apply.
          <br />
          You may be able to submit information or content (“Material”) to the
          Service. INDIA TODAY GROUP does not claim ownership in your Material.
          Your submission of Material does not transfer ownership of rights of
          the Material to INDIA TODAY GROUP. INDIA TODAY GROUP is only
          transmitting the Material and is not responsible for editorial control
          over it.
          <br />
          Any liability arising out of the use of your Material shall not be
          borne by the INDIA TODAY GROUP and you shall keep the INDIA TODAY
          GROUP indemnified and harmless in this regard. By submitting Material
          to the Service you grant INDIA TODAY GROUP a world-wide,
          non-exclusive, sub-licensable, assignable, fully paid-up,
          royalty-free, perpetual and irrevocable license to use, copy, publicly
          perform, display, distribute in any media and modify the Material to
          incorporate the Material into other works, and to grant similar
          sublicenses to the extent necessary for INDIA TODAY GROUP to provide
          the Service.
          <br />
          You are solely responsible for taking backup copies of the data you
          store on the Service, including Content you upload. If the Service is
          discontinued or canceled, INDIA TODAY GROUP may permanently delete
          your data. INDIA TODAY GROUP has no obligation to return data to you
          after the Service is discontinued or canceled.
        </p>
        <p className="text-slate-600 text-md">
          <strong className="text-lg text-slate-950 py-2">
            4. Using the Service
          </strong>
        </p>
        <p className="text-slate-600 text-md">
          You agree to: Comply with applicable laws, these Terms and good
          manners;
          <br />
          Use the Service only for your personal, non-commercial purposes;
          <br />
          Not submit unlawful, offensive, inaccurate, misleading, abusive,
          pornographic, harassing, libelous, blasphemous, defamatory, obscene,
          pedophilic, invasive of another’s privacy, hateful, racially or
          ethically objectionable, disparaging, relating to or encouraging money
          laundering or gambling, or otherwise inappropriate material.
          <br />
          Not to upload or share any information that impersonates another
          person, threatens the unity, integrity, defence, security or
          sovereignty of India.
          <br />
          Obtain any consents, permission or licenses that may be legally
          required for you to submit any Material;
          <br />
          Respect the privacy of others;
          <br />
          Not distribute or post spam, unreasonably large files, chain letters,
          pyramid schemes, viruses; or Not use any other technologies or
          initiate other activities that may harm the Service, or the interest
          or property of the Service users.
          <br />
          Not to use any automated systems or means to access, acquire, copy or
          monitor any part of the service.
          <br />
          Be responsible for the consequences related to the Material that you
          post.
          <br />
          Report any abuse of the above terms at the below email id
          <br />
          INDIA TODAY GROUP may but has no obligation to: Monitor or moderate
          any Content or Material; Remove any Material from the Service; and
          Restrict access to any part of the Service at any time in its sole
          discretion.
        </p>
        <p className="text-slate-600 text-md">
          <strong className="text-lg text-slate-950 py-2">5. Content</strong>
        </p>
        <p className="text-slate-600 text-md">
          Before downloading or accessing any Content, please check whether the
          Content which you wish to access is restricted by age or marked as
          potentially ‘offensive’ or ‘explicit’. INDIA TODAY GROUP shall not be
          responsible for any claims or offense caused or suffered by you
          accessing such Content. You agree:
          <br />
          To use the Content only for your personal, non-commercial purposes; To
          use the Content in accordance with the restrictions set out in the
          applicable laws, additional terms, guidelines and policies or on the
          product pages that apply to that particular piece of the Content;
          <br />
          Not to make copies, give, sell, resell, loan, rent, offer, broadcast,
          send, distribute, transfer, communicate to the public, reproduce,
          modify, display, perform, commercially exploit or make the Content
          available unless otherwise authorized in the applicable Terms and to
          advise INDIA TODAY GROUP promptly of any such unauthorized use;
          <br />
          Not to remove, circumvent, reverse engineer, decrypt, or otherwise
          alter or interfere with any applicable usage rules or attempt to
          circumvent digital rights management or copy protection features
          associated with the Content or any other technologies used to control
          the access to or use of the Content or its identifying information;
          Not to use any automated systems or means, except for those provided
          by us, for the selection or downloading of the Content;
          <br />
          Not to give out your password or otherwise allow other people to
          access the Content. The restrictions on copying that apply to
          applicable media also apply to the Content accessed as part of this
          Service.
          <br />
          The Content is owned and/or controlled by INDIA TODAY GROUP and/or its
          respective licensors and is protected by intellectual property laws.
          The third party Content provider is solely responsible for any Content
          it provides, any warranties to the extent that such warranties have
          not been disclaimed and for any claims you may have relating to that
          Content or your use of that Content.
          <br />
          However, INDIA TODAY GROUP reserves the right to enforce the third
          party Content license terms against you as a third party beneficiary
          of those terms. The third party Content providers are third-party
          beneficiaries under these Terms and may enforce the provisions that
          directly concern the Content in which they have rights. INDIA TODAY
          GROUP may be acting as an agent for third party Content provider in
          providing the Content to you. INDIA TODAY GROUP is not a party to the
          transaction between you and the third party Content provider for such
          Content.
        </p>
        <p className="text-slate-600 text-md">
          <strong className="text-lg text-slate-950 py-2">6. Notices</strong>
        </p>
        <p className="text-slate-600 text-md">
          INDIA TODAY GROUP may post notices within the Service. INDIA TODAY
          GROUP may also send you notices about products and Services to the
          email address or telephone number you have provided to us. You are
          deemed to have received such notices at the latest within seven
          (7)days from INDIA TODAY GROUP sending or posting those. Your
          continued use of the Services constitutes your receipt of all notices
          regardless of delivery method.
        </p>
        <p className="text-slate-600 text-md">
          <strong className="text-lg text-slate-950 py-2">7. Fees</strong>
        </p>
        <p className="text-slate-600 text-md">
          Your use of the Service may be or may become subject to charges.
          <br />
          Use of the Service may involve transmission of data through your
          service provider’s network. Prices listed within the Service do not
          include possible data transmission, text message, voice or other
          service provision charges by your network service provider.
          <br />
          INDIA TODAY GROUP assumes no responsibility for the payment of any
          charges of your service providers.
        </p>
        <p className="text-slate-600 text-md">
          <strong className="text-lg text-slate-950 py-2">
            8. Order and Payment Terms
          </strong>
        </p>
        <p className="text-slate-600 text-md">
          “Order” shall mean the selection of payable Content and/or
          subscription to Content offered by INDIA TODAY GROUP and available in
          the Service and submission of payment method, as well as submitting
          the order by selecting the “buy”, “ok”, “I accept” or other similar
          confirmation of acceptance in the order flow or providing other
          indication of acceptance terms that are presented to you in the order
          flow.
          <br />
          You agree that all Orders shall be legally valid and binding. All
          Orders are subject to acceptance by INDIA TODAY GROUP.
          <br />
          You may pay by credit or debit card, network service provider billing,
          or other payment methods if available.
          <br />
          Your credit or debit card must have a billing address in the country
          where the Content is offered by the Service. INDIA TODAY GROUP will
          charge your credit card or debit your bank account within a reasonable
          time after you have made your Order. All credit card payments are
          subject to validation checks and authorization by the card issuer.
          <br />
          If you choose network service provider billing, charges will appear on
          your mobile phone bill or be deducted from your prepaid account if it
          is a prepaid account. Some network service providers may subject your
          usage of the Service to additional terms and conditions including
          placing limits on the amount of charges possible with network service
          provider billing. Charges in excess of network service provider limits
          or account balance may be rejected.
          <br />
          You agree to pay the charges related to your Order, to ensure that the
          instrument of payment is valid at the time of the Order, that you are
          the rightful holder of the instrument and that the instrument is used
          within its credit limits.
          <br />
          The Content that is delivered is licensed to you. You agree to use
          such Content solely as permitted in these Terms and in any additional
          terms that you may be presented in the order flow.
          <br />
          The Service may offer subscriptions. You authorize the Service to
          place a periodical charge during the period of the subscription. The
          Service may also offer a trial period. If your Order involves a trial
          period (also known as try-and-buy), you may be charged when the trial
          period expires, unless you cancel in accordance with the
          subscription/trial terms.
          <br />
          The prices in the Service may change from time to time. Prices include
          applicable taxes in effect at the time of your transaction, unless
          otherwise stated. There may be instances where you incur additional
          charges from your bank or credit card provider based on currency
          conversion rates used and/or additional fees assessed.
        </p>
        <p className="text-slate-600 text-md">
          <strong className="text-lg text-slate-950 py-2">
            INDIA TODAYGROUP SERVICE TERMS
          </strong>
        </p>
        <address className="text-slate-600 text-md">
          Privacy
          <br />
          The Company Web-sites (“Site”) are maintained by:
          <br />
          THE INDIA TODAY GROUP
          <br />
          MEDIAPLEX
          <br />
          FC-8, SECTOR – 16A,
          <br />
          FILM CITY,
          <br />
          NOIDA – 201301
          <br />
          We can be reached at [
          <a
            className="text-primary"
            href="http://www.indiatodaygroup.com/new-site/publications/ite.html"
          >
            Contact Us
          </a>
          ]
        </address>
        <p className="text-slate-600 text-md">
          Any personal information identifying any visitor to the INDIA TODAY
          GROUP Sites or Subscriber (“Personal Information”) if required, is
          asked for explicitly in the relevant page on the INDIA TODAY GROUP
          Sites. Personal Information is used to operate the INDIA TODAY GROUP
          Sites, and we may occasionally inform you of new features, services,
          and products from the Company.
          <br />
          We may place a text file called a “cookie” in the browser files of
          your computer. The cookie itself does not contain Personal Information
          although it will enable the INDIA TODAY GROUP Sites to relate your use
          of the INDIA TODAY GROUP Sites to information that you have
          specifically and knowingly provided to the INDIA TODAY GROUP Sites.
          <br />
          If at any time you believe the INDIA TODAY GROUP Sites have not
          adhered to these principles, please notify at&nbsp;
          <a href="http://www.indiatodaygroup.com/new-site/publications/ite.html">
            Contact Us
          </a>
          &nbsp;and we will use all commercially reasonable efforts to promptly
          determine and correct the problem.
          <br />
          If you have questions about this policy,&nbsp;
          <a href="http://www.indiatodaygroup.com/new-site/publications/ite.html">
            Contact Us
          </a>
        </p>
        <p className="text-slate-600 text-md">
          <strong className="text-lg text-slate-950 py-2">
            9. Feedback to INDIA TODAY GROUP
          </strong>
        </p>
        <p className="text-slate-600 text-md">
          By submitting any ideas, feedback and/or proposals (“Feedback”) to
          INDIA TODAY GROUP through the Service or other means, you acknowledge
          and agree that: (1) INDIA TODAY GROUP may have similar development
          ideas to the Feedback; (2) your Feedback does not contain confidential
          or proprietary information of you or any third party; (3) INDIA TODAY
          GROUP is not under any obligation of confidentiality with respect to
          the Feedback; (4) INDIA TODAY GROUP may freely use, distribute,
          exploit and further develop and modify Feedback for any purpose; and
          (5) you are not entitled to any compensation of any kind from INDIA
          TODAY GROUP.
        </p>
        <p className="text-slate-600 text-md">
          <strong className="text-lg text-slate-950 py-2">
            10. Social Activities and Location Sharing
          </strong>
        </p>
        <p className="text-slate-600 text-md">
          You may use features in the Service to share your location, status,
          content, Materials or personal information or to interact with other
          users, sites and services. By using these features you agree that
          INDIA TODAY GROUP may use and provide that information to other
          services and persons with whom you choose to interact or share this
          information. Users of these services and persons, such as your
          contacts, may see your location, status and/or personal information.
          In using these features you agree not to share information, Content or
          Material, or to link to any service or site containing information,
          Content or Material, that: (a) contains content or other material that
          is illegal or inappropriate; (b) exploits intellectual property rights
          without authorization or encourages users to piracy; or (c) contains
          sensitive personal data of others. Any interaction does not involve
          INDIA TODAY GROUP and is solely between you and the other user(s).
        </p>
        <p className="text-slate-600 text-md">
          <strong className="text-lg text-slate-950 py-2">
            11. Availability and Technical Requirements
          </strong>
        </p>
        <p className="text-slate-600 text-md">
          The availability of Content and the Service may vary and is subject to
          INDIA TODAY GROUP’s sole discretion. INDIA TODAY GROUP expressly
          disclaims any representation or warranty that any particular Content
          or Service will be available. The Service, operations and some
          features may also be dependent on the network, compatibility of the
          devices used and the content formats supported.
          <br />
          To access the Service, you may need to download a specific piece of
          software developed by INDIA TODAY GROUP or by another party.
          <br />
          INDIA TODAY GROUP may, in its sole discretion, change, correct or
          discontinue the Service in whole or in part. INDIA TODAY GROUP may
          disable any Content or Software contained in your Service account for
          any reason and remove any Content or Software and/or disable copies of
          any application on your device in order to protect the Service,
          application providers, wireless carriers over whose network you access
          the service or any other affected or potentially affected parties.
        </p>
        <p className="text-slate-600 text-md">
          <strong className="text-lg text-slate-950 py-2">
            12. Links to Third Party Sites and Content
          </strong>
        </p>
        <p className="text-slate-600 text-md">
          INDIA TODAY GROUP may include access to sites and services on the
          Internet or preloaded clients that enable you to interact with sites
          and services that are owned or operated by thirdparties and that are
          not part of the Service. You must review and agree to the terms and
          conditions of these sites or services before using these sites
          orservices.
          <br />
          INDIA TODAY GROUP has no control over the third party content, sites
          or services and assumes no responsibility for services provided or
          material created or published on these third-partysites or services. A
          link to a third-party site does not imply that INDIA TODAY GROUP
          endorses the site or the products or services referenced in the site.
          <br />
          In addition, you and other users may create content and links to
          content within the Service that has not otherwise been submitted to
          the Service. INDIA TODAY GROUP is not responsible for this type of
          content or links.
        </p>
        <p className="text-slate-600 text-md">
          <strong className="text-lg text-slate-950 py-2">
            13. Advertisements
          </strong>
        </p>
        <p className="text-slate-600 text-md">
          Service may include advertisements. Advertisements may be targeted to
          the content or information stored on the Service, queries made through
          the Service, or other information.
        </p>
        <p className="text-slate-600 text-md">
          <strong className="text-lg text-slate-950 py-2">
            14. Personal Data
          </strong>
        </p>
        <p className="text-slate-600 text-md">
          The Privacy Policy and any additional privacy information made
          available to you govern the use of your personal data.
        </p>
        <p className="text-slate-600 text-md">
          <strong className="text-lg text-slate-950 py-2">
            15. Limitation of Liability
          </strong>
        </p>
        <p className="text-slate-600 text-md">
          The Service is provided on “AS IS” and “AS AVAILABLE” basis. INDIA
          TODAY GROUP does not warrant that the Service will be uninterrupted or
          error or virus-free. No warranty of any kind, either express or
          implied, including but not limited to warranties of title,
          non-infringement, merchantability, or fitness for a particular
          purpose, is made in relation to the availability, accuracy,
          reliability, information or content of the Service. You expressly
          agree and acknowledge that the use of the Service is at your sole risk
          and that you may be exposed to content from various sources.
          <br />
          INDIA TODAY GROUP is not liable for any direct damages caused by your
          use or inability to use the Service. In no case will INDIA TODAY GROUP
          be liable for any indirect, incidental, punitive or consequential
          damages resulting from your use or inability to use the Service.
        </p>
        <p className="text-slate-600 text-md">
          <strong className="text-lg text-slate-950 py-2">
            16. Indemnification
          </strong>
        </p>
        <p className="text-slate-600 text-md">
          You agree to defend and indemnify INDIA TODAY GROUP from and against
          all third party claims and all liabilities, assessments, losses, costs
          or damages resulting from or arising out of (i) your breach of these
          Terms, (ii) your infringement or violation of any intellectual
          property rights, other rights or privacy of a third party, or (iii)
          misuse of the Service by a third party where the misuse was made
          possible by your failure to take reasonable measures to protect your
          username and password against misuse..
        </p>
        <p className="text-slate-600 text-md">
          <strong className="text-lg text-slate-950 py-2">
            17. Miscellaneous
          </strong>
        </p>
        <p className="text-slate-600 text-md">
          17.1 Choice of Law
          <br />
          These Terms are governed by the laws of India. The Courts at New Delhi
          shall have exclusive jurisdiction over any dispute arising out of your
          use of the Service.
          <br />
          17.2 Changes in Terms
          <br />
          INDIA TODAY GROUP may modify the Terms at any time without prior
          notice. If the Terms are changed in a material, adverse way, INDIA
          TODAY GROUP will provide a separate notice advising of the change.
          <br />
          You are responsible for regularly reviewing the Terms. Your continued
          use of the Service constitutes your consent to any changes and
          modification.
        </p>
        <p className="text-slate-600 text-md">
          <strong className="text-lg text-slate-950 py-2">
            18. Intellectual Property
          </strong>
        </p>
        <p className="text-slate-600 text-md">
          The Service, Content and Software are protected under the copyright
          laws. INDIA TODAY GROUP claims copyrights in its Service, Content, and
          Software to the maximum extent of the law. Subject to the Terms, INDIA
          TODAY GROUP retains all rights, titles and interests in the Service,
          its Content, the Software and in all other INDIA TODAY GROUP products,
          software and other properties provided to you or used by you through
          the Service.
        </p>
        <p className="text-slate-600 text-md">
          <strong className="text-lg text-slate-950 py-2">
            19. Assignment
          </strong>
        </p>
        <p className="text-slate-600 text-md">
          INDIA TODAY GROUP may assign its rights and obligations under these
          Terms to its subsidiaries, or to any company under common control with
          INDIA TODAY GROUP. Additionally, INDIA TODAY GROUP may assign its
          rights and obligations under these Terms to a third party inconnection
          with a merger, acquisition, sale of assets, by operation of law or
          otherwise
        </p>
        <p className="text-slate-600 text-md">
          <strong className="text-lg text-slate-950 py-2">
            20. Grievance Redressal
          </strong>
        </p>
        <p className="text-slate-600 text-md">
          In compliance with Rule 11(2)(a) of the Information Technology
          (Intermediary Guidelines and Digital Media Ethics Code) Rules, 2021,
          T.V. Today Network Limited, New Delhi which owns and operates digital
          news platforms, including but not limited to ‘www.aajtak.in’ and
          ‘www.indiatoday.in’, has appointed the following person as the
          Grievance Officer and who will be responsible for redressal of
          grievances received by him in terms of the said Rules. The name of the
          Grievance Officer and the contact details are as follows:
        </p>
        <p className="text-slate-600 text-md"></p>
        <p className="text-slate-600 text-md">
          Name: M.N. Nasser Kabir
          <br />
          Group General Counsel, India Today Group
          <br />
          TV Today Network Ltd.
          <br />
          India Today Mediaplex
          <br />
          FC 8, Sec. 16 A, Film City, Noida 201301
          <br />
          E-mail: grievanceofficer@aajtak.com
          <br />
          WhatsApp No.: 70424-89008
        </p>
        <p className="text-slate-600 text-md"></p>
        <p className="text-slate-600 text-md">
          Before making a Grievance, complainants are encouraged to go through
          the above-mentioned Rules along with the self-regulating mechanism
          provided therein. The same can also be accessed at: Click Here
          <br />
          [Disclaimer: T.V. Today Network Limited is a member of the Digital
          News Publishers Association (DNPA). DNPA for and on behalf of its
          members including T.V. Today Network Limited has challenged the
          Information Technology (Intermediary Guidelines and Digital Media
          Ethics Code) Rules, 2021 and the said challenge is pending before the
          Hon’ble High Court of Judicature, Madras in W.P. No. 13055 and 12515
          of 2021. The present disclosure is made without prejudice to the said
          challenge.]
        </p>
      </div>
    </article>
  );
};

export default index;
